import React from 'react';

import withLayout from '../../hoc/withLayout';

function NoPageFound() {
    return (
        <React.Fragment>
            <strong>Oops! Couldn't find the page you where looking for.</strong>
        </React.Fragment>
    )
}

export default withLayout(NoPageFound);
